var i;(function(e){e.simple="simple",e.circle="circle",e.default="simple"})(i||(i={}));export{i as ButtonIconStyle};
